import React, { useState } from "react";
import Main from "./Main";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";

import "primeicons/primeicons.css";
import PDFMerger from "pdf-merger-js";

const PdfMerge = () => {
  const [files, setFiles] = useState([]);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const pdfFiles = selectedFiles.filter(
      (file) => file.type === "application/pdf"
    );
    setFiles(pdfFiles);
  };

  const removeFile = (index) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  const removeAll = () => {
    console.table(files);
    if (window.confirm("Remove All ?")) {
      setFiles([]);
    } else {
      console.log("Canceled!");
    }
  };

  const merge = () => {
    if (files.length == 0) {
      alert("No files Found");
      return 0;
    }
    var merger = new PDFMerger();

    (async () => {
      // await merger.add("pdf1.pdf"); //merge all pages. parameter is the path to file and filename.
      // await merger.add("pdf2.pdf", 2); // merge only page 2
      // await merger.add("pdf2.pdf", [1, 3]); // merge the pages 1 and 3
      // await merger.add("pdf2.pdf", "4, 7, 8"); // merge the pages 4, 7 and 8
      // await merger.add("pdf3.pdf", "3 to 5"); //merge pages 3 to 5 (3,4,5)
      // await merger.add("pdf3.pdf", "3-5"); //merge pages 3 to 5 (3,4,5)

      for (const file of files) {
        await merger.add(file);
      }

      // Set metadata
      await merger.setMetadata({
        producer: "pdf-merger-js based script",
        author: "ESU IT",
        creator: "ESU IT Department",
        title: "PDF",
      });

      await merger.save("merged.pdf"); //save under given name and reset the internal document
    })();
  };

  return (
    <>
      <Main />
      <Container fluid>
        <Row className="m-1" style={{ border: "solid 1px" }}>
          <Col className="m-2 border-primary" sm={6}>
            <div style={{ display: "flex", margin: "3px" }} className="">
              <Form.Group controlId="formFile" className="">
                <Form.Control
                  type="file"
                  multiple
                  onChange={handleFileChange}
                  accept=".pdf"
                  id="uploads"
                  hidden
                />
                <i
                  className="pi pi-file-pdf text-danger"
                  onClick={() => document.getElementById("uploads").click()}
                  style={{ cursor: "pointer", fontSize: "40px" }}
                ></i>
              </Form.Group>

              <Form.Group controlId="formFile" className="">
                <i
                  className="pi pi-file-arrow-up text-primary "
                  style={{ cursor: "pointer", fontSize: "40px" }}
                  onClick={(e) => merge()}
                ></i>
              </Form.Group>
              <Form.Group controlId="formFile" className="">
                <i
                  className="pi pi-times-circle text-warning "
                  style={{ cursor: "pointer", fontSize: "40px" }}
                  onClick={(e) => removeAll()}
                ></i>
              </Form.Group>
            </div>

            <div className="file-names">
              {files.map((file, index) => (
                <div key={index} className="small">
                  {file.name}
                  <i
                    className="pi pi-times text-danger"
                    style={{ fontSize: "1rem", cursor: "pointer" }}
                    onClick={() => removeFile(index)}
                  ></i>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PdfMerge;
